import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { getSuitesJSON } from './utils/api';
import CarouselManagerAppV2 from './components/CarouselManagerAppV2-Slick/CarouselManagerAppV2-Slick';

ReactDOM.render(
    <CarouselManagerAppV2
        blockTitle={'Certificate Courses'}
        blockTitleClass={'ubuntu--light h2'}
        route={'/suites/'}
        data={getSuitesJSON}
    />,
    document.getElementById('courseTilesBlock')
);